// src/app/App.jsx
import React from "react";
import { AuthProvider } from "../auth/AuthContext";
import { CartProvider } from "../features/cart/CartContext";
import AppRoutes from "./routes";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";

const App = () => {
  return (
    <AuthProvider>
      <CartProvider>
        <Navbar/>
        <AppRoutes />
        <Footer/>
      </CartProvider>
    </AuthProvider>
  );
};

export default App;